<template>
  <nna-container>
    <div class="align-middle">  
      <md-icon class="md-size-4x">check_circle</md-icon>
      <h1 class="md-title">Ordine inviato</h1>
      <p>Numero Ordine:</p>
      <h2 class="md-title">#{{order.number}}</h2>
      <div v-html="order.msg"></div>
    </div>
  </nna-container>  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'CheckoutDone',
  computed: {
    ...mapGetters({
      order: 'order/order',
    })
  },
  mounted() {
    setTimeout(()=> this.$router.push({ path: `/profile/order/${this.$route.query.id}` }), 5000)
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/Shop/pages/CheckoutDone.vue